function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as R } from "react/jsx-runtime";
import * as n from "react";
import { useTheme as A, useAriaId as _ } from "./hooks.js";
import { FormContext as q } from "./form-context.js";
import B from "classnames";
import { sprinkles as L } from "./sprinkles.css-mistica.js";
process.env.NODE_ENV !== "test" && typeof document < "u" && !("scrollBehavior" in document.documentElement.style) && import("scroll-behavior-polyfill").finally(()=>{});
const W = (param)=>{
    let { children: S , className: x , onSubmit: b , initialValues: h = {} , autoJump: k = !1 , onValidationErrors: a , id: C  } = param;
    const f = n.useRef(!0), [i, E] = n.useState(h), [l, I] = n.useState(h), [w, m] = n.useState("filling"), [V, y] = n.useState({}), c = n.useRef(/* @__PURE__ */ new Map()), d = n.useRef(null), { texts: g  } = A(), v = _(C);
    n.useEffect(()=>(f.current = !0, ()=>{
            f.current = !1;
        }), []);
    const j = n.useCallback((e, param)=>{
        let { input: r , validator: o , focusableElement: t  } = param;
        r || t ? c.current.set(e, {
            input: r,
            validator: o,
            focusableElement: t
        }) : c.current.delete(e);
    }, []), P = (param)=>{
        let { name: e , error: r  } = param;
        return y((o)=>_object_spread_props(_object_spread({}, o), {
                [e]: r
            }));
    }, p = n.useCallback(()=>{
        var o;
        const e = {};
        for (const [t, { input: s , validator: u  }] of c.current)if (s) {
            if (s.disabled) continue;
            if (s.required && !((o = l[t]) != null && o.trim())) e[t] = g.formFieldErrorIsMandatory;
            else {
                const N = u == null ? void 0 : u(i[t], l[t]);
                N && (e[t] = N);
            }
        }
        const r = Object.keys(e).map((t)=>{
            const s = c.current.get(t);
            return (s == null ? void 0 : s.focusableElement) || (s == null ? void 0 : s.input);
        }).filter(Boolean);
        if (r.length) {
            r.sort((t, s)=>t.compareDocumentPosition(s) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1), r[0].focus();
            try {
                r[0].scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
            } catch (e) {}
        }
        return y(e), a && Object.keys(e).length > 0 && a(e), e;
    }, [
        a,
        l,
        g,
        i
    ]), T = n.useCallback((e)=>{
        setTimeout(()=>{
            var r;
            if (k && d.current) {
                const o = Array.from(d.current.querySelectorAll("input, select")), t = (r = c.current.get(e)) == null ? void 0 : r.input, s = o.indexOf(t);
                if (s >= 0) {
                    const u = o[s + 1];
                    u ? u.focus() : t == null || t.blur();
                }
            }
        }, 100);
    }, [
        k
    ]), O = (e)=>[
            ...c.current.keys()
        ].reduce((r, o)=>{
            var t, s;
            return (s = (t = c.current.get(o)) == null ? void 0 : t.input) != null && s.disabled ? r : _object_spread_props(_object_spread({}, r), {
                [o]: e[o]
            });
        }, {}), F = n.useCallback((e)=>(e == null || e.preventDefault(), m("sending"), Object.keys(p()).length > 0 ? (m("filling"), Promise.resolve()) : Promise.resolve(b(O(i), O(l))).finally(()=>{
            f.current && m("filling");
        })), [
        b,
        l,
        p,
        i
    ]), D = n.useCallback((param)=>{
        let { name: e , value: r  } = param;
        E((o)=>_object_spread_props(_object_spread({}, o), {
                [e]: r
            }));
    }, []), M = n.useCallback((param)=>{
        let { name: e , value: r  } = param;
        I((o)=>_object_spread_props(_object_spread({}, o), {
                [e]: r
            }));
    }, []);
    return /* @__PURE__ */ R(q.Provider, {
        value: {
            formStatus: w,
            values: i,
            setValue: D,
            rawValues: l,
            setRawValue: M,
            formErrors: V,
            setFormError: P,
            register: j,
            jumpToNext: T,
            validate: p,
            submit: F,
            formId: v
        },
        children: /* @__PURE__ */ R("form", {
            id: v,
            onSubmit: F,
            ref: d,
            className: B(L({
                width: "100%"
            }), x),
            noValidate: !0,
            children: S
        })
    });
}, K = W;
export { K as default };
